import React, { useMemo } from 'react';
import { translate } from '@utils/i18n';
import { ChartView } from '@ui/molecules/ChartView';
import { DashboardCard } from '@ui/molecules/DashboardCard';
import { PRIMARY_PURPLE, GREEN, RED } from '../constants';
const namespace = 'features.dashboards.inspection_assistant_insights_v2';
function IssuesCaughtChart({ data, isLoading }) {
    const caughtLabel = translate('chart.caught', { namespace });
    const resolvedLabel = translate('chart.resolved', { namespace });
    const escapedLabel = translate('chart.escaped', { namespace });
    const chartBlock = useMemo(() => ({
        type: 'chart',
        block_id: 'issues-caught-vs-resolved',
        block_index: 0,
        chart_type: 'line',
        data: {
            labels: data.map((d) => d.week),
            datasets: [
                { label: caughtLabel, data: data.map((d) => d.caught), color: PRIMARY_PURPLE },
                { label: resolvedLabel, data: data.map((d) => d.resolved), color: GREEN },
                { label: escapedLabel, data: data.map((d) => d.escaped), color: RED }
            ]
        },
        options: { show_legend: true, show_values: false }
    }), [data, caughtLabel, resolvedLabel, escapedLabel]);
    return (React.createElement(DashboardCard, { title: translate('chart.title', { namespace }), subtitle: translate('chart.subtitle', { namespace }), isLoading: isLoading }, data.length === 0 ? React.createElement("p", null, translate('chart.no_data', { namespace })) : React.createElement(ChartView, { block: chartBlock })));
}
export default IssuesCaughtChart;
